import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { LiabilityBusinessFeatureConfig } from '../../../types/insurances/LiabilityBusinessFeatureConfig';
import { liabilityBusiness as base } from './base';
import { liabilityBusiness as RO } from './RO';

export const liabilityBusinessConfig: InsuranceIndex<LiabilityBusinessFeatureConfig> = { base, RO };
